import { ChainId } from 'bakery-swap-sdk'

export const AuctionBake = 1368385838
export const MAXSCROLLNUM = 2000

export const CollectionImgErr: any = {
  logoImage: {
    size: 50 * 1024 * 1024,
    err: 'Upload Logo image',
    errSize: 'Picture exceeds 10M'
  },
  featuredImage: {
    size: 50 * 1024 * 1024,
    err: 'Upload Featured cover',
    errSize: 'Picture exceeds 10M'
  },
  bannerImage: {
    size: 50 * 1024 * 1024,
    err: 'Upload Banner image',
    errSize: 'Picture exceeds 10M'
  }
}
export const CollectionInfo = {
  name: {
    text: '',
    err: 'Enter the collection name',
    errShow: false,
    placeholder: 'Example: Doughnut surprise'
  },
  logoImage: {
    text: '',
    err: 'Upload Logo image',
    errShow: false,
    placeholder: 'Upload Logo image',
    loading: false,
    file: ''
  },
  featuredImage: {
    text: '',
    err: 'Upload Featured image',
    errShow: false,
    placeholder: 'Upload Featured image',
    loading: false,
    file: ''
  },
  bannerImage: {
    text: '',
    err: 'Upload Banner image',
    errShow: false,
    placeholder: 'Upload Banner image',
    loading: false,
    file: ''
  },
  description: {
    text: '',
    err: 'Enter the brief introduction',
    errShow: false,
    placeholder: 'Enter the brief introduction'
  },
  royalties: {
    text: '',
    err: '',
    errShow: false,
    placeholder: 'e.g. 2.4',
    leftText: 'Percentage fee:'
  },
  links: {
    text: '',
    err: '',
    errShow: false,
    placeholder: 'Yoursite.io',
    leftIcon: 'images/nft/input_icon.png'
  }
}

export const MintOptions = [{
  sortName: '1',
  sortBy: 'asc',
  key: 1,
  name: 'Picture',
  accept: '.jpg, .png, .jpeg',
  isTab: true,
  img: require('../../assets/images/artwork_img.svg')
}, {
  sortName: '2',
  sortBy: 'desc',
  key: 2,
  name: 'GIF',
  accept: '.gif',
  isTab: true,
  img: require('../../assets/images/artwork_gif.svg')
}, {
  sortName: '1',
  sortBy: 'asc',
  key: 3,
  name: 'Video',
  accept: '.mp4, .flv',
  isTab: true,
  img: require('../../assets/images/artwork_video.svg')
}, {
  sortName: '2',
  sortBy: 'desc',
  key: 4,
  name: 'Audio',
  accept: '.mp3',
  isTab: true,
  img: require('../../assets/images/artwork_audio.svg')
}]

export const SortOptions = [{
  sortName: 'blockCreateTime',
  sortBy: 'desc',
  key: 7,
  name: 'Time',
},{
  sortName: 'blockCreateTime',
  sortBy: 'asc',
  key: 8,
  name: 'Time',
},{
  sortName: 'price',
  sortBy: 'asc',
  key: 1,
  name: 'Price',
}, {
  sortName: 'price',
  sortBy: 'desc',
  key: 2,
  name: 'Price',
}, {
  sortName: 'votes',
  sortBy: 'asc',
  key: 5,
  name: 'Votes',
}, {
  sortName: 'votes',
  sortBy: 'desc',
  key: 6,
  name: 'Votes',
}]
export const PetSortOption = [{
  sortName: 'price',
  sortBy: 'asc',
  key: 1,
  name: 'Price',
}, {
  sortName: 'price',
  sortBy: 'desc',
  key: 2,
  name: 'Price',
}, {
  sortName: 'battlePower',
  sortBy: 'asc',
  key: 3,
  name: 'Power',
}, {
  sortName: 'battlePower',
  sortBy: 'desc',
  key: 4,
  name: 'Power',
}]
export const WeaponSortOption = [{
  sortName: 'price',
  sortBy: 'asc',
  key: 1,
  name: 'Price',
}, {
  sortName: 'price',
  sortBy: 'desc',
  key: 2,
  name: 'Price',
}, {
  sortName: 'stakingPower',
  sortBy: 'asc',
  key: 3,
  name: 'Power',
}, {
  sortName: 'stakingPower',
  sortBy: 'desc',
  key: 4,
  name: 'Power',
}]
export const ComboSortOption = [{
  sortName: 'price',
  sortBy: 'asc',
  key: 1,
  name: 'Price',
}, {
  sortName: 'price',
  sortBy: 'desc',
  key: 2,
  name: 'Price',
}, {
  sortName: 'stakingPowerAmount',
  sortBy: 'asc',
  key: 3,
  name: 'Power',
}, {
  sortName: 'stakingPowerAmount',
  sortBy: 'desc',
  key: 4,
  name: 'Power',
}]

export const SortOptions2 = [{
  sortName: 'price',
  sortBy: 'asc',
  key: 1,
  name: 'Price',
}, {
  sortName: 'price',
  sortBy: 'desc',
  key: 2,
  name: 'Price',
}]

export const BscTokenOptions = [{
  sortName: '',
  sortBy: 'desc',
  key: 1,
  name: 'BAKE',
  isTab: true
}, {
  sortName: '',
  sortBy: 'desc',
  key: 2,
  name: 'BUSD',
  isTab: true
}]

export const TokenOptions = [{
  sortName: '',
  sortBy: 'desc',
  key: 1,
  name: 'RACA',
  isTab: true
}, {
  sortName: '',
  sortBy: 'desc',
  key: 2,
  name: 'DOGGY',
  isTab: true
}, {
  sortName: '',
  sortBy: 'desc',
  key: 3,
  name: 'BARK',
  isTab: true
}, {
  sortName: '',
  sortBy: 'desc',
  key: 4,
  name: 'DOGE',
  isTab: true
}]

export const TokauTokenOptions = [{
  sortName: '',
  sortBy: 'desc',
  key: 1,
  name: 'BAKE',
  isTab: true
}, {
  sortName: '',
  sortBy: 'desc',
  key: 2,
  name: 'TOKAU',
  isTab: true
}, {
  sortName: '',
  sortBy: 'desc',
  key: 3,
  name: 'BUSD',
  isTab: true
}]

export const TabOptions = [{
  sortName: '',
  sortBy: 'desc',
  key: 5,
  name: 'All',
  isTab: true
},{
  sortName: '1',
  sortBy: 'asc',
  key: 3,
  name: 'Picture',
  isTab: true
},{
  sortName: '2',
  sortBy: 'desc',
  key: 4,
  name: 'GIF',
  isTab: true
}, {
  sortName: '3',
  sortBy: 'asc',
  key: 7,
  name: 'Video',
  isTab: true
}, {
  sortName: '4',
  sortBy: 'desc',
  key: 8,
  name: 'Audio',
  isTab: true
}]

export const UserTabOptions = [{
  sortName: '',
  sortBy: 'desc',
  key: 1,
  name: 'All',
  isTab: true
},{
  sortName: '1',
  sortBy: 'asc',
  key: 2,
  name: 'In Wallet',
  isTab: true
}, {
  sortName: '2',
  sortBy: 'desc',
  key: 3,
  name: 'On Sale',
  isTab: true
}, {
  sortName: '2',
  sortBy: 'desc',
  key: 4,
  name: 'On Auction',
  isTab: true
}, {
  sortName: '2',
  sortBy: 'desc',
  key: 5,
  name: 'Offer made',
  isTab: true
}]

export const AuditOptions: any[] = [{
  name: 'refuse',
  value: -1,
  defaultChecked: true
}, {
  name: 'approve',
  value: 1
}]

export const defaultArtworks = {
  tokenId: '',
  price: '',
  name: '',
  description: '',
  imageUrl: '',
  fileUrl: '',
  fileType: 1,
  votes: '',
  owner: '',
  status: 1,
  creator: '',
  nftType: 3,
  nftId: '',
  staking: false,
  id: '',
  attributes: {
    artist: '',
    edition: '',
    image_min: '',
    public_profile_link: '',
    image_link: ''
  },
  auctionPrice: '',
  maxBidPrice: '',
  author: ''
}

export interface ArtworksProps {
  tokenId: string
  name: string
  description: string
  imageUrl: string
  fileUrl: string
  fileType: number
  maxBidPrice: string
  author: string
  price?: string
  votes?: string
  owner?: string
  nftType?: number
  nftId?: string
  auctionPrice?: string
  staking?: false
  creator?: string
  id?: string
  status?: number
  exchangeAddress?: string
  quoteToken?: string
  tokenName?: string
  level?: string
  nftLevel?: string
  attributes: {
    artist: string
    edition: string
    image_min: string
    public_profile_link?: string
    cover_url?: string
    image_link?: string
    creatorRoyalties?: any
    Level?: string
  }
}

export interface ArtworkProps {
  nftId: string
  price: number
  name: string
  nftType: number
  description: string
  imageUrl: string
  fileUrl: string
  fileType: number
  maxBidPrice: string
  author: string
  votes?: string
  owner?: string
  status?: number
  auctionPrice?: string
  creator?: string
  id?: string
  exchangeAddress?: string
  quoteToken?: string
  attributes: {
    artist: string
    edition: string
    image_min: string
    public_profile_link?: string
    cover_url?: string
    image_link?: string
    minImage?: string
  }
}

export const imgErr: any = {
  artworkImage: {
    size: 50 * 1024 * 1024,
    err: 'Upload Artwork image',
    errSize: 'Picture exceeds 10M'
  },
  artworkCover: {
    size: 50 * 1024 * 1024,
    err: 'Upload Artwork cover',
    errSize: 'Picture exceeds 10M'
  },
  artworkVideo: {
    size: 300 * 1024 * 1024,
    err: 'Upload artwork video',
    errSize: 'Video exceeds 30M'
  },
  artworkAudio: {
    size: 300 * 1024 * 1024,
    err: 'Upload artwork audio',
    errSize: 'Audio exceeds 30M'
  }
}

export const briefintrExp = new RegExp('^(.{0,' + 500 + '}).*$')
export const editionExp = new RegExp('^[0-9]+/[0-9]+$')
export const linkExp = new RegExp(/^https?:\/\/([\w-]+\.)+[\w-]+.*$/)
export const mintInfo = {
  name: {
    text: '',
    err: 'Enter the artwork name',
    errShow: false,
    placeholder: 'Enter the artwork name',
    star: '*',
    optional: ''
  },
  artistName: {
    text: '',
    err: 'Enter the artist name',
    errShow: false,
    placeholder: 'Enter the artist name',
    star: '*',
    optional: ''
  },
  profileLink: {
    text: '',
    err: '',
    errShow: false,
    placeholder: 'Personal website, Instagram, Twitter, etc.',
    leftIcon: 'images/nft/input_icon.png'
  },
  briefintr: {
    text: '',
    err: 'Enter the brief introduction',
    errShow: false,
    placeholder: 'Enter the brief introduction',
    star: '*',
    optional: ''
  },
  royalties: {
    text: '0',
    err: 'Enter the Royalties',
    errShow: false,
    placeholder: 'E.g. 10%',
    star: '*',
    optional: ''
  },
  artworkImage: {
    text: '',
    errShow: false,
    placeholder: 'Upload Artwork image',
    file: '',
    format: '',
    progressBar: {
      show: false,
      progress: 0,
      complete: true
    },
    star: '*',
    optional: ''
  }
}
export const VideoInfo = {
  text: '',
  errShow: false,
  placeholder: 'Upload Artwork Video',
  file: '',
  format: '',
  progressBar: {
    show: false,
    progress: 0,
    complete: true
  },
  star: '*',
  optional: ''
}
export const AudioInfo = {
  text: '',
  errShow: false,
  placeholder: 'Upload Artwork Audio',
  progressBar: {
    show: false,
    progress: 0,
    complete: true
  },
  star: '*',
  optional: ''
}
export const ImageInfo = {
  text: '',
  errShow: false,
  placeholder: 'Upload Artwork image',
  progressBar: {
    show: false,
    progress: 0,
    complete: true
  },
  star: '*',
  optional: ''
}

export const exchangeUrl: any = {
  BAKERYARTWORK: '/exchange/new-artworks',
  SEASCAPE: '/exchange/seascape',
  ONEINCH: '/exchange/oneInch',
  MEME: '/exchange/meme',
  MUSKDOGE: '/exchange/musk-doge',
  BAKERYSOCCER: '/exchange/bakerySoccer',
  TKONFT: '/exchange/tko-nft',
  BTCARTWORK: '/exchange/digital-artworks',
  SFPARTWORK: '/exchange/sfpNft',
  POKER: '/gamification/poker',
  GAMEBOX: '/gamification/gameBox',
  CAR: '/gamification/car',
  DOGGIES: '/gamification/doggies',
  BARKING: '/gamification/barking',
  LOVE: '/exchange/520love',
  YOOSHINFT: '/exchange/yooshi',
  RACANFT: '/exchange/radioCaca',
  BONDLYNFT: '/exchange/bondly',
  TOKAUMULTITOKEN: '/exchange/tokau',
  MATRIXMULTITOKEN: '/exchange/radioCaca',
  TOYMULTITOKEN: '/exchange/toynft',
  KAKAMULTITOKEN: '/exchange/kakanft',
  EQUIPMENT: '/gamification/equipment'
}

export const noArtworkTitle: any = {
  '106': "You don't own any poker blindbox",
  '103': "You don't own any rare car box",
  '104': "You don't have any crypto doggy nft",
  '108': "You don't have any barking nft",
  '114': "You don't have any doggy equipment nft",
  POKER: "You don't own any poker blindbox",
  GAMEBOX: "You don't own any bsc game box",
  CAR: "You don't own any rare car box",
  DOGGIES: "You don't have any crypto doggy nft",
  BARKING: "You don't have any barking nft",
  EQUIPMENT: "You don't have any doggy equipment nft"
}

export const noArtworkBtn: any = {
  '104': "Go to Crypto Doggy Shop",
  '108': "Go to Barking Shop",
  '114': "Go to Doggy Equipment Shop",
  DOGGIES: "Go to Crypto Doggy Shop",
  BARKING: "Go to Barking Shop",
  EQUIPMENT: "Go to Doggy Equipment Shop"
}

export const noArtworkSale: any = {
  '104': "There is no doggy on sale",
  '108': "There is no barking on sale",
  '114': "There is no doggy equipment on sale",
  DOGGIES: "There is no doggy on sale",
  BARKING: "There is no barking on sale",
  EQUIPMENT: "There is no doggy equipment on sale"
}

export const artInfoUrl: any = {
  BAKERYBSCARTWORK: '/exchange/bsc-artworks/artworkInfo/',
  BAKERYARTWORK: '/exchange/new-artworks/artworkInfo/',
  SEASCAPE: '/exchange/seascape/seascapeInfo/',
  ONEINCH: '/exchange/oneInch/oneInchInfo/',
  MEME: '/exchange/meme/memeInfo/',
  MUSKDOGE: '/exchange/musk-doge/muskdogeInfo/',
  BAKERYSOCCER: '/exchange/soccer/bakerySoccerInfo/',
  TKONFT: '/exchange/tkonft/tkonftInfo/',
  BTCARTWORK: '/exchange/digital-artworks/artworkInfo/',
  SFPARTWORK: '/exchange/sfpNft/sfpInfo/',
  LOVE: '/exchange/520love/520loveInfo/',
  RACANFT: '/exchange/radioCaca/radioCacaInfo/',
  BONDLYNFT: '/exchange/bondly/bondlyInfo/',
  MATRIXMULTITOKEN: '/exchange/matrix/matrixInfo/',
  TOYMULTITOKEN: '/exchange/toy/toyInfo/',
  s: '/exchange/kaka/kakaInfo/',
  RACAMULTITOKEN: '/exchange/radioCaca/radioCacaInfo/'
}

export const mintType: any = {
  nftType: {
    BAKERYARTWORK: 3,
    SEASCAPE: 6,
    ONEINCH: 8,
    MEME: 5,
    MUSKDOGE: 4,
    TKONFT: 7,
    BTCARTWORKS: 1,
    SOCCER: 100,
    SFPARTWORK: 101,
    LOVE: 105,
    RACANFT: 107,
    MATRIXMULTITOKEN: 113,
    TOYMULTITOKEN: 115,
    KAKAMULTITOKEN: 116
  },
  title: {
    BAKERYARTWORK: 'BSC Artists',
    SEASCAPE: 'Seascape',
    ONEINCH: '1inch & BAKE',
    MEME: 'BAKE & Banana',
    MUSKDOGE: 'Musk & Doge',
    TKONFT: 'Tko Nft',
    SFPARTWORK: 'SafeNFT',
    LOVE: 'LoveNFT',
    RACANFT: 'Radio Caca NFT',
    MATRIXMULTITOKEN: 'Matrix Plus Box',
    TOYMULTITOKEN: 'Toy Nft',
    KAKAMULTITOKEN: 'Kaka Nft',
    BAKERYBSCARTWORK: 'BSC Artists',
  },
  charges: {
    BAKERYARTWORK: 'Mint an NFT charges 0.01BNB, please do not upload any sensitive content.',
    SEASCAPE: 'Mint an NFT charges 0.01BNB, please do not upload any sensitive content.',
    ONEINCH: 'Mint an NFT charges 0.01BNB, please do not upload any sensitive content.',
    MEME: 'Mint an NFT charges 0.01BNB, please do not upload any sensitive content.',
    MUSKDOGE: 'Mint an NFT charges 0.01BNB, please do not upload any sensitive content.',
    SFPARTWORK: 'Please do not upload any sensitive content.',
    LOVE: 'Mint an NFT charges 0.01BNB, please do not upload any sensitive content.',
    RACANFT: 'Mint an NFT charges 0.01BNB, please do not upload any sensitive content.',
    BAKERYBSCARTWORK: 'Mint an NFT charges 0.01BNB, please do not upload any sensitive content.'
  }
}

export const CONTRACT_ADDRESSES: { [contract: string]: { [chainId: string]: string } } = {
  digitalArtworkNft: {
    [ChainId.BSC_TESTNET]: '0xe5f1ac1971f28cf8cbea5fee6fe61b1dd8908141',
    [ChainId.BSC_MAINNET]: '0xbc9535ceb418a27027f5cc560440f4a8823cb8bf'
  }
}


